import { Heading, Loader } from '@fourthwall/components';
import React from 'react';
import * as S from './styled';
export const UploadLoader = () => {
    return (React.createElement(S.Container, null,
        React.createElement(Loader, { appearance: "primary", size: "large" }),
        React.createElement(Heading, { type: "h6", weight: "semibold" },
            React.createElement(S.HeadingText, null, "Your file is being uploaded..."))));
};
